export default function guest({ next, router, from }) {
    if (localStorage.getItem('access_token')) {
        return router.push({ name: 'dashboard' });
    }

    document.body.classList.add('login-page')
    return next();
}